module.exports = __webpack_public_path__ + "img/2928664.svg";